import {
  EDITOR_ATTACH_TO_CONTAINER,
  EDITOR_CONTENT_GRID_RENDER_ITEMS, EDITOR_CONTENT_GRID_ADD_FIELD,
  EDITOR_CONTENT_GRID_TOGGLE_FIELD_VISIBILITY,
  EDITOR_CONTENT_GRID_REMOVE_WIDGET, EDITOR_CONTENT_GRID_UPDATE_CONTENT,
  EDITOR_UPDATE_WIDGET_CONTENT, EDITOR_CHANGE_CONTENT_GRID_CARD,

  UPDATE_LAYOUT_MANAGER_FOR_CONTENT_GRID_REQUEST, UPDATING_LAYOUT_MANAGER_FOR_CONTENT_GRID_SUCCEEDED, UPDATING_LAYOUT_MANAGER_FOR_CONTENT_GRID_FAILED,
  FETCH_MAPPINGS_FOR_CONTENT_GRID_REQUEST, FETCHING_MAPPINGS_FOR_CONTENT_GRID_SUCCEEDED, FETCHING_MAPPINGS_FOR_CONTENT_GRID_FAILED,
  CREATE_LAYOUT_MANAGER_FOR_CONTENT_GRID_REQUEST, CREATING_LAYOUT_MANAGER_FOR_CONTENT_GRID_SUCCEEDED, CREATING_LAYOUT_MANAGER_FOR_CONTENT_GRID_FAILED, FETCHING_CONTENT_CARD_SUCCEEDED,
  UPDATE_DYNAMIC_LAYOUT_MANAGER, UPDATE_FILTERS_IN_CONTENT_GRID, RESET_FILTERS_IN_CONTENT_GRID, UPDATE_QUERY_IN_CONTENT_GRID
} from "constants/actionTypes";

import { CONTENT_CARD_TEMPLATE, CONTENT_CARD, TEXT, IMAGE, BASIC_TEXT, BUTTON } from "constants/widgetTypes";

import _ from 'lodash';
import buildUrl from 'build-url';
import axios from 'axios';
import shortid from 'shortid';

import { createAction } from "redux-actions";
import { put, select, takeEvery, call, take } from "redux-saga/effects";
import {
  applyWidgetPropertyChanges, attachWidgetToContainer, createWidget,
  deleteWidgets, updateWidgetLayout, updateWidgetProperty
} from "./editor";
import { fetchContentCard, invalidateContentCard } from "./contentCards";
import FileService from "services/file.service";

const apiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
const LAYOUT_URL = `${apiUrl}/api/2.0/content/layout`;
const READ_MORE = 'Read more →';
const VIEW_MORE = 'View more →';
const VIEW_NOW = 'View now →';
const WATCH_NOW = 'Watch now →';
const LISTEN_NOW = 'Listen now →';

/**
 * Content Grid implementation
*/
export const renderItemsForContentGrid = createAction(EDITOR_CONTENT_GRID_RENDER_ITEMS, (editorSession, widget, items) => {
  return {
    editorSession: editorSession,
    widget: widget,
    items: items
  }
});

function* renderItemsForContentGridSaga(action) {
  const { editorSession, widget } = action.payload;
  const pageId = editorSession.split("_")[1];
  const page = yield select((state) =>
       _.get(state, `pages.page.${pageId}.item`, [])
    );
  const variableMappings = _.get(page, "variableMappings", []);

  const contentGrid = yield select(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`) || [];
    return widgets.find(item => item.uid === widget);
  });

  const cardTemplate = yield select(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`) || [];
    const template = widgets.find(item => item.parent === widget && item.type === CONTENT_CARD_TEMPLATE);

    const _cleanData = (widget) => {
      const children = widget.widgets;
      if (_.size(children) > 0) {
        widget.widgets = children.map(child => _cleanData(child));
      }

      return _.omit(widget, ['id', 'uid', 'parent']);
    }

    const _findChildren = (parent) => {
      return widgets.filter(widget => widget.parent === parent);
    }

    const _buildTemplateRequest = (widget) => {
      const widgetVariables = variableMappings.filter(vm => vm.widget === widget.uid);
      const widgetRequest = {
        ...widget,
        template: {
          widget: widget.uid,
          contentGrid: contentGrid.uid
        }
      };
      if (widgetVariables.length > 0) {
        widgetRequest.variableMappings = widgetVariables;
      }

      var children = _findChildren(widget.uid);

      if (_.size(children) > 0) {
        widgetRequest.widgets = children
          .map(child => _buildTemplateRequest(child))
          .sort((w1, w2) => {
            const o1 = _.get(w1, 'order') || 1;
            const o2 = _.get(w2, 'order') || 1;

            return o1 - o2;
          });
      }

      return widgetRequest;
    }

    if (template == null) {
      return null;
    }

    var templateRequest = _buildTemplateRequest(template);
    templateRequest = _cleanData(templateRequest);

    return templateRequest;
  });

  if (!cardTemplate) {
    return;
  }

  const existingWidgets = yield select(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`) || [];
    return widgets.filter(item => _.get(item, 'template.contentGrid') === contentGrid.uid).map(item => item.uid);
  });

  const items = _.get(contentGrid, 'content.mappings.items') || [];
  const widgets = items.map((item, index) => {
    return createCardFromTemplate(contentGrid, cardTemplate, item, index);
  });

  yield put(deleteWidgets(editorSession, existingWidgets));
  yield put(createWidget(editorSession, widgets, contentGrid.uid, false));
}

const createCardFromTemplate = (contentGrid, cardTemplate, item, index) => {

  const _updateContent = (widget, item) => {
    const children = widget.widgets;
    if (_.size(children) > 0) {
      widget.widgets = children.map(child => _updateContent(child, item));
    }

    const content = calculateContent(contentGrid, widget, item);
    const desktop = calculateVisibility(contentGrid, widget, item, 'desktop');
    const mobile = calculateVisibility(contentGrid, widget, item, 'mobile');

    return {
      ...widget,
      content: content,
      properties: {
        'desktop': {
          ...widget.properties.desktop,
          visible: desktop
        },
        'mobile': {
          ...widget.properties.mobile,
          visible: mobile
        }
      }
    };
  }

  const calculateContent = (contentGrid, widget, item) => {
    const content = widget.content || '';
    const fields = item.fields || [];
    const overrideKey = widget.parameter || _.get(widget, 'template.widget');

    if (!_.includes([BASIC_TEXT, TEXT, IMAGE, BUTTON], widget.type)) {
      return content;
    }

    const contentGridOverrides = _.get(contentGrid, `content.changes.${item.id}`) || {};
    const hasChanges = _.has(contentGridOverrides, `overrides.${overrideKey}.content`);
    const contentType = _.get(contentGrid, `content.type`) || 'MANUAL';
    if (hasChanges) {
      return _.get(contentGridOverrides, `overrides.${overrideKey}.content`, '');
    }

    if (widget.parameter) {
      const field = fields.find(f => f.name === widget.parameter);

      var fieldOverride = _.get(field, 'override', false);

      if (widget.type === BUTTON && widget.parameter === "cta" && !fieldOverride) {
        if(contentType === 'DYNAMIC' && widget?.content) {
          return widget?.content;
        }

        if (item.content.asset.entityType === "page") {
            return item.content.asset.storyboardType === "INTERACTIVE_CONTENT" ? VIEW_NOW : VIEW_MORE;
        }

        var fileType = FileService.fileType(item.content.asset.metadata);
        var fieldContent = VIEW_NOW;
    
        switch (fileType) {
            case "PDF":
            case "DOC":
            case "DOCX":
            case "PPT":
            case "PPTX":
                fieldContent = READ_MORE;
                break;
            case "IMAGE":
                fieldContent = VIEW_NOW;
                break;
            case "AUDIO":
                fieldContent = LISTEN_NOW;
                break;
            case "VIDEO":
                fieldContent = WATCH_NOW;
                break;
            case "LINK":
                fieldContent = VIEW_MORE;
                break;
        }
    
        return fieldContent;
    }
    
      var fieldContent = _.get(field, 'content', '');
      if (field && field.name === 'icon') {
        return fieldContent || {
          type: 'image',
          url: '/public/cleverstory/v2/static/default_card.jpg'
        };
      }

      if(!field && _.includes(widget.parameter, "custom_")) {
        let fieldContent = "";
        const mappedFields = _.get(item, `content.customFields`);

        if(mappedFields) {
          fieldContent = calculateContentForCustomField(mappedFields, widget.parameter);
        }
        return fieldContent;
      }

      return fieldContent;
    }

    if (widget.template && widget.template.widget) {
      const field = fields.find(f => f.name === widget.template.widget);
      if (field && field.override) {
        return _.get(field, 'content', '');
      }
    }

    return content;
  }

  const calculateContentForCustomField = (mappedFields, parameter) => {
    let fieldContent = "";
    const fieldId = parameter.split("_")[1] || null;

    if (fieldId) {
      const field = mappedFields.find(item => item.id === fieldId);
      const values = _.get(field, `value`) || [];

      if(values.length > 0) {
        values.map((value, index) => {

          if(index == 0) {
            fieldContent = value.value;
          } else {
            fieldContent = fieldContent + "," + value.value;
          }

        });
      }
    }
    return fieldContent;
  }

  const calculateVisibility = (contentGrid, widget, item, breakpoint) => {
    const fields = item.fields || [];
    var visibility = _.get(widget, `properties.${breakpoint}.visible`);
    const overrideKey = widget.parameter || _.get(widget, 'template.widget');

    if (_.includes([CONTENT_CARD], widget.type)) {
      return visibility;
    }

    if(!visibility){
      return false;
    }

    const contentGridOverrides = _.get(contentGrid, `content.changes.${item.id}`) || {};
    if (_.has(contentGridOverrides, `overrides.${overrideKey}.${breakpoint}`)) {
      return _.get(contentGridOverrides, `overrides.${overrideKey}.${breakpoint}`);
    }

    if (widget.parameter) {
      const field = fields.find(f => f.name === widget.parameter);
      if (field) {
        return _.get(field, breakpoint);
      }
    }

    if (widget.template && widget.template.widget) {
      const field = fields.find(f => f.name === widget.template.widget);
      if (field) {
        return _.get(field, breakpoint);
      }
    }

    return visibility;
  }

  var card = {
    ...cardTemplate,
    order: item.order,
    template: {
      ...cardTemplate.template,
      content: item,
      index: index
    },
    type: CONTENT_CARD
  }

  card = _updateContent(card, item);
  return card;
}

function* attachWidgetToTemplateContainer(action) {
  const { editorSession, widget, container, layout } = action.payload;

  const parentContainer = yield select(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`) || [];
    return widgets.find(item => item.uid === container);
  });

  if (parentContainer == null || !parentContainer.template) {
    return;
  }

  const template = parentContainer.template;
  yield put(updateWidgetLayout(editorSession, widget, 'desktop', layout));
  yield put(attachWidgetToContainer(editorSession, template.widget, widget, layout));
  yield put(renderItemsForContentGrid(editorSession, template.contentGrid));
}

/**
 * Change content card template
 * 
*/
export const changeContentGridCard = createAction(EDITOR_CHANGE_CONTENT_GRID_CARD, (editorSession, contentGrid, card) => {
  return {
    editorSession: editorSession,
    contentGrid: contentGrid,
    card: card
  }
})

function* changeContentGridCardSaga(action) {
  const { editorSession, contentGrid, card } = action.payload;

  yield put(fetchContentCard(card));
  yield take(FETCHING_CONTENT_CARD_SUCCEEDED);

  const contentCard = yield select(state => _.get(state, `contentCards.card.${card}.item`, null));

  const cardWidgets = _.get(contentCard, 'content.widgets');

  const existingWidgets = yield select(state => {
    const _findChildren = (parent) => {
      return widgets.filter(widget => widget.parent === parent);
    }
  
    const widgets = _.get(state, `${editorSession}.present.widgets`) || [];

    const existingTemplate = widgets.find(item => item.type === CONTENT_CARD_TEMPLATE && item.parent === contentGrid);
    const existingChildren = _findChildren(existingTemplate.uid);

    var exitingWidgets = [existingTemplate, ...existingChildren];
    return exitingWidgets.map(item => item.uid);
  });

  var newTemplate = cardWidgets.find(item => item.type === CONTENT_CARD_TEMPLATE);
  newTemplate = _.omit(newTemplate, ['id', 'uid', 'parent']);

  var newChildren = cardWidgets.filter(item => item.type !== CONTENT_CARD_TEMPLATE);
  newChildren = (newChildren || []).map(item => {
    return _.omit(item, ['id', 'uid', 'parent']);
  });

  newChildren = _.orderBy(newChildren, ["order", "asc"]);

  newTemplate = {
    ...newTemplate,
    uid: `widget_${shortid.generate()}`,
    widgets: newChildren
  };

  yield put(createWidget(editorSession, [newTemplate], contentGrid));
  yield put(deleteWidgets(editorSession, existingWidgets));
  yield put(renderItemsForContentGrid(editorSession, contentGrid));
  yield put(invalidateContentCard());
}

/**
 * Add field to card in content grid 
 * 
*/
export const addFieldToContentGrid = createAction(EDITOR_CONTENT_GRID_ADD_FIELD, (editorSession, widget, field, breakpoint) => {
  return {
    editorSession: editorSession,
    widget: widget,
    field: field,
    breakpoint: breakpoint
  }
});

function* addFieldToContentGridSaga(action) {
  const { editorSession, widget, field, breakpoint } = action.payload;

  const cardTemplate = yield select(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`) || [];
    return widgets.find(item => item.parent === widget && item.type === CONTENT_CARD_TEMPLATE);
  });

  const customFields = yield select(state => {
    const fields = _.get(state, `fields.items`) || [];
    return fields;
  });


  if (!cardTemplate) {
    return;
  }

  const calculateLayoutForBreakpoint = (field, breakpoint) => {
    var cardWidth = _.get(cardTemplate, `properties.${breakpoint}.layout.width`);
    var cardHeight = _.get(cardTemplate, `properties.${breakpoint}.layout.height`);

    cardWidth = parseFloat(cardWidth);
    cardHeight = parseFloat(cardHeight);

    var width = field.widgetConfig.width;
    var height = field.widgetConfig.height;


    width = Math.min(cardWidth, width);
    height = Math.min(cardHeight, height);

    var x = (cardWidth - width) / 2;
    var y = (cardHeight - height) / 2;

    x = Math.max(x, 0);
    y = Math.max(y, 0);

    return {
      x: x,
      y: y,
      width: width,
      height: height
    }
  }

  const createWidgetRequest = (field, breakpoint) => {
    const widgetConfig = field.widgetConfig;

    const desktopLayout = calculateLayoutForBreakpoint(field, 'desktop');
    const mobileLayout = calculateLayoutForBreakpoint(field, 'mobile');

    return {
      type: widgetConfig.type,
      name: field.name,
      parameter: field.parameter,
      properties: {
        desktop: {
          visible: breakpoint === 'desktop' ? true : false,
          layout: {
            transform: {
              translate: `${desktopLayout.x}px, ${desktopLayout.y}px`,
              rotate: "0deg",
            },
            width: `${desktopLayout.width}px`,
            height: `${desktopLayout.height}px`,
          },
          font: {
            fontFamily: 'Montserrat,sans-serif',
            fontSize: 16,
            lineSpacing: 1.2
          }
        },
        mobile: {
          visible: breakpoint === 'mobile' ? true : false,
          layout: {
            transform: {
              translate: `${mobileLayout.x}px, ${mobileLayout.y}px`,
              rotate: "0deg",
            },
            width: `${mobileLayout.width}px`,
            height: `${mobileLayout.height}px`,
          },
          fontSize: 18,
          lineSpacing: 1.2,
          letterSpacing: 0,
        },
      },
      content: _.includes(field.parameter, "custom_") ? field.name : ""
    };
  }

  const fieldRequest = createWidgetRequest(field, breakpoint);
  yield put(createWidget(editorSession, [fieldRequest], cardTemplate.uid, false));
  yield put(renderItemsForContentGrid(editorSession, widget));
}


/**
 * Add field to card in content grid 
 * 
*/
export const removeWidgetFromContentGrid = createAction(EDITOR_CONTENT_GRID_REMOVE_WIDGET, (editorSession, contentGrid, widget) => {
  return {
    editorSession: editorSession,
    contentGrid: contentGrid,
    widget: widget
  }
});

function* removeWidgetFromContentGridSaga(action) {
  const { editorSession, contentGrid, widget } = action.payload;

  const cardTemplate = yield select(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`) || [];
    return widgets.find(item => item.parent === contentGrid && item.type === CONTENT_CARD_TEMPLATE);
  });

  if (!cardTemplate) {
    return;
  }

  const existingWidgets = yield select(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`) || [];
    return widgets.filter(item => _.get(item, 'template.widget') === widget).map(item => item.uid);
  });

  const widgetsToDelete = [widget, ...existingWidgets];
  yield put(deleteWidgets(editorSession, widgetsToDelete));
}

/**
 * Toggle field visibility in content card
*/
export const toggleFieldVisibilityInContentCard = createAction(EDITOR_CONTENT_GRID_TOGGLE_FIELD_VISIBILITY, (editorSession, contentCard, widget, breakpoint, visibility) => {
  return {
    editorSession: editorSession,
    contentCard: contentCard,
    widget: widget,
    breakpoint: breakpoint,
    visibility: visibility
  }
});

function* toggleFieldVisibilityInContentCardSaga(action) {
  const { editorSession, contentCard, widget, breakpoint, visibility } = action.payload;

  const contentGridProps = yield select(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`) || [];
    return widgets.find(item => item.uid === contentCard.template.contentGrid);
  });

  const cardTemplate = yield select(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`) || [];
    return widgets.find(item => item.parent === contentCard.template.contentGrid && item.type === CONTENT_CARD_TEMPLATE);
  });

  const currentBreakpoint = yield select(state => _.get(state, `${editorSession}.present.breakpoint`));

  if (!contentGridProps || !cardTemplate) {
    return;
  }

  const gridContent = _.get(contentGridProps, 'content');
  var changes = _.get(gridContent, 'changes') || {};

  const mapping = contentCard.template.content;
  const key = widget.parameter || widget.template.widget;

  changes[mapping.id] = {
    id: mapping.id,
    type: mapping.type,
    overrides: {
      ...(changes[mapping.id] || { overrides: {} }).overrides,
      [key]: {
        ...(_.get(changes, `${mapping.id}.overrides['${key}']`) || {}),
        key: key,
        custom: widget.parameter == null,
        [breakpoint]: visibility
      }
    }
  }

  const changeRequest = {
    [contentGridProps.uid]: {
      id: contentGridProps.uid,
      path: `content.changes`,
      value: changes
    }
  }

  changeRequest[widget.uid] = {
    id: widget.uid,
    path: `properties.${breakpoint}.visible`,
    value: visibility
  }

  yield put(applyWidgetPropertyChanges(editorSession, changeRequest, currentBreakpoint));
}

/**
 * Update content in asset card
 */
export const updateContentInContentGrid = createAction(EDITOR_CONTENT_GRID_UPDATE_CONTENT, (editorSession, contentGrid, widget, content) => {
  return {
    editorSession: editorSession,
    contentGrid: contentGrid,
    widget: widget,
    content: content
  }
});

function* updateContentInContentGridSaga(action) {
  const { editorSession, contentGrid, widget, content } = action.payload;

  const contentGridProps = yield select(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`) || [];
    return widgets.find(item => item.uid === contentGrid);
  });
  const currentBreakpoint = yield select(state => _.get(state, `${editorSession}.present.breakpoint`));

  const layoutType = _.get(contentGridProps, 'content.type', '');

  const cardTemplate = yield select(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`) || [];
    return widgets.find(item => item.parent === contentGrid && item.type === CONTENT_CARD_TEMPLATE);
  });

  if (!contentGridProps || !cardTemplate) {
    return;
  }

  const updateContent = _.includes([BASIC_TEXT, TEXT, IMAGE, BUTTON], widget.type) && layoutType !== 'DYNAMIC';
  if (updateContent) {
    const contentCard = yield select(state => {
      const widgets = _.get(state, `${editorSession}.present.widgets`) || [];

      const _findParent = (widgets, widget) => {
        const item = widgets.find(item => item.uid === widget);

        if (!item) {
          return null;
        }

        const type = _.get(item, 'type');
        if (type === CONTENT_CARD) {
          return item;
        }

        if (item && item.parent) {
          return _findParent(widgets, item.parent)
        }
      }

      const parent = _findParent(widgets, widget.uid);
      return parent;
    });

    const mapping = contentCard.template.content;
    const key = widget.parameter || widget.template.widget;

    const gridContent = _.get(contentGridProps, 'content');
    var changes = _.get(gridContent, 'changes') || {};

    changes[mapping.id] = {
      id: mapping.id,
      type: mapping.type,
      overrides: {
        ...(changes[mapping.id] || { overrides: {} }).overrides,
        [key]: {
          key: key,
          custom: widget.parameter == null,
          content: content,
          override: true
        }
      }
    }

    const changeRequest = {
      [contentGrid]: {
        id: contentGrid,
        path: `content.changes`,
        value: changes
      }
    }

    yield put(applyWidgetPropertyChanges(editorSession, changeRequest, currentBreakpoint));
  }else{
    const templateWidget = _.get(widget, 'template.widget');
    if(!templateWidget){
      return;
    }

    const changeRequest = {
      [templateWidget]: {
        id: templateWidget,
        path: `content`,
        value: content
      }
    }

    yield select(state => {
      var widgets = _.get(state, `${editorSession}.present.widgets`) || [];
      widgets.filter(item => _.get(item, 'template.widget') === templateWidget)
      .forEach(item => {
        changeRequest[item.uid] = {
          id: item.uid,
          path: `content`,
          value: content
        }
      });
    });

    yield put(applyWidgetPropertyChanges(editorSession, changeRequest, currentBreakpoint));
  }
}

function* updateWidgetContentSaga(action) {
  const { editorSession, widget, content } = action.payload;

  const widgetProps = yield select(state => {
    const items = _.get(state, `${editorSession}.present.widgets`) || [];
    return items.find(item => item.uid === widget);
  });

  if (!widgetProps) {
    return;
  }

  if (widgetProps.template) {
    const contentGrid = widgetProps.template.contentGrid;
    yield put(updateContentInContentGrid(editorSession, contentGrid, widgetProps, content));
  }
}

/**
 * ------------------------------------------------------------
 * Update filters in Content gird
 * ------------------------------------------------------------
*/
export const updateFiltersInContenGrid = createAction(UPDATE_FILTERS_IN_CONTENT_GRID, (editorSession, widget, filter) => {
  return {
    editorSession: editorSession,
    widget: widget,
    filter: filter
  }
})


/**
 * ------------------------------------------------------------
 * Update Query in Content gird
 * ------------------------------------------------------------
*/
export const updateQueryInContenGrid = createAction(UPDATE_QUERY_IN_CONTENT_GRID, (editorSession, widget, query) => {
  return {
    editorSession: editorSession,
    widget: widget,
    query: query
  }
})

/**
 * ------------------------------------------------------------
 * Reset filters in Content gird
 * ------------------------------------------------------------
*/
export const resetFiltersInContenGrid = createAction(RESET_FILTERS_IN_CONTENT_GRID, (editorSession, widget) => {
  return {
    editorSession: editorSession,
    widget: widget
  }
})

/**
 * ------------------------------------------------------------
 * Fetch content mapping for layout
 * ------------------------------------------------------------
*/
export const fetchMappingsForContentGrid = createAction(FETCH_MAPPINGS_FOR_CONTENT_GRID_REQUEST, (editorSession, widget, page, limit, preview) => {
  return {
    editorSession: editorSession,
    widget: widget,
    page: page,
    limit: limit,
    preview: preview
  }
});

const fetchingMappingsForContentGridSucceeded = createAction(FETCHING_MAPPINGS_FOR_CONTENT_GRID_SUCCEEDED,
  (editorSession, widget, response, preview) => {
    return {
      editorSession: editorSession,
      widget: widget,
      response: response,
      preview: preview
    }
  }
);

const fetchingMappingsForContentGridFailed = createAction(FETCHING_MAPPINGS_FOR_CONTENT_GRID_FAILED,
  (editorSession, widget, layout, error) => {
    return {
      editorSession: editorSession,
      widget: widget,
      error: error
    }
  }
);

function* fetchMappingsForContentGridSaga(action) {
  const { editorSession, widget, page, limit, preview } = action.payload;

    yield put(renderItemsForContentGrid(editorSession, widget));

  const fetchContentMappingsAPI = (layout, request) => {

    const params = {
      page: page,
      limit: limit
    };

    let url = buildUrl(LAYOUT_URL, {
      path: `${layout}/mappings`,
      queryParams: params
    });

    return axios.post(url, request).then(response => response.data);
  }

  try {
    const contentWidget = yield select(state => {
      const widgets = _.get(state, `${editorSession}.present.widgets`) || [];
      return widgets.find(item => item.uid === widget);
    })

    const layout = yield select(state => {
      const widgets = _.get(state, `${editorSession}.present.widgets`) || [];
      const contentGrid = widgets.find(item => item.uid === widget);
      return _.get(contentGrid, 'content.id');
    });

    var request = {}
    const filters = _.get(contentWidget, 'filters', []);
    const query = _.get(contentWidget, 'query', '');
    if(filters && filters.length > 0) {
      request = {
        ...request,
        commands: filters
      }
    }

    if(query) {
      request = {
        ...request,
        query: query
      }
    }

    if(!layout){
      yield put(fetchingMappingsForContentGridSucceeded(editorSession, widget, {
        records: [],
        pagination: {
          currentPage: 0,
          totalPages: 0
        }
      }));

      return;
    }

    const response = yield call(fetchContentMappingsAPI, layout, request);
    if (response) {
      yield put(fetchingMappingsForContentGridSucceeded(editorSession, widget, response, preview));
      yield put(renderItemsForContentGrid(editorSession, widget));
    }
  } catch (error) {
    console.log(error);
    yield put(fetchingMappingsForContentGridFailed(editorSession, widget, error));
  }
}

/**
 * ------------------------------------------------------------
 * Create layout manager contents
 * ------------------------------------------------------------
*/
export const createLayoutManagerForContentGrid = createAction(CREATE_LAYOUT_MANAGER_FOR_CONTENT_GRID_REQUEST,
  (editorSession, widget, request) => {
    return {
      editorSession: editorSession,
      widget: widget,
      request: request
    };
  }
)

export const creatingLayoutManagerForContentGridSuccedded = createAction(CREATING_LAYOUT_MANAGER_FOR_CONTENT_GRID_SUCCEEDED,
  (editorSession, widget, response) => {
    return {
      editorSession: editorSession,
      widget: widget,
      response: response
    };
  }
)

export const creatingLayoutManagerForContentGridFailed = createAction(CREATING_LAYOUT_MANAGER_FOR_CONTENT_GRID_FAILED,
  (editorSession, widget, error) => {
    return {
      editorSession: editorSession,
      widget: widget,
      error: error
    };
  }
)

function* createLayoutManagerForContentGridSaga(action) {
  const { editorSession, widget, request } = action.payload;
  const createLayoutAPI = () => {
    return axios.post(LAYOUT_URL, request).then(response => response.data);
  }

  try {
    const response = yield call(createLayoutAPI);
    if (response) {
      yield put(creatingLayoutManagerForContentGridSuccedded(editorSession, widget, response));
      yield put(fetchMappingsForContentGrid(editorSession, widget, 0, 3));
    }
  } catch (error) {
    yield put(creatingLayoutManagerForContentGridFailed(editorSession, widget, error));
  }
}


/**
 * ------------------------------------------------------------
 * Update layout manager contents
 * ------------------------------------------------------------
*/
export const updateLayoutManagerForContentGrid = createAction(UPDATE_LAYOUT_MANAGER_FOR_CONTENT_GRID_REQUEST,
  (editorSession, widget, layout, request) => {
    return {
      editorSession: editorSession,
      widget: widget,
      layout: layout,
      request: request
    };
  }
)

export const updatingLayoutManagerForContentGridSuccedded = createAction(UPDATING_LAYOUT_MANAGER_FOR_CONTENT_GRID_SUCCEEDED,
  (editorSession, widget, request, response) => {
    return {
      editorSession: editorSession,
      widget: widget,
      request: request,
      response: response
    };
  }
)

export const updatingLayoutManagerForContentGridFailed = createAction(UPDATING_LAYOUT_MANAGER_FOR_CONTENT_GRID_FAILED,
  (editorSession, widget, error) => {
    return {
      editorSession: editorSession,
      widget: widget,
      error: error
    };
  }
)

function* updateLayoutManagerForContentGridSaga(action) {
  const { editorSession, widget, layout, request } = action.payload;

  let url = buildUrl(LAYOUT_URL, {
    path: `${layout}`
  });

  const updateLayoutAPI = () => {
    return axios.put(url, request).then(response => response.data);
  }

  try {
    const response = yield call(updateLayoutAPI);
    if (response) {
      yield put(updatingLayoutManagerForContentGridSuccedded(editorSession, widget, request, response));
    }
  } catch (error) {
    yield put(updatingLayoutManagerForContentGridFailed(editorSession, widget, error));
  }
}

export const updateDynamicLayoutManager = createAction(UPDATE_DYNAMIC_LAYOUT_MANAGER, (editorSession, request) => {
  return {
    editorSession: editorSession,
    request: request
  }
})

export default function* contentGridSaga() {
  yield takeEvery(FETCH_MAPPINGS_FOR_CONTENT_GRID_REQUEST, fetchMappingsForContentGridSaga);
  yield takeEvery(CREATE_LAYOUT_MANAGER_FOR_CONTENT_GRID_REQUEST, createLayoutManagerForContentGridSaga);
  yield takeEvery(UPDATE_LAYOUT_MANAGER_FOR_CONTENT_GRID_REQUEST, updateLayoutManagerForContentGridSaga);

  yield takeEvery(EDITOR_CONTENT_GRID_RENDER_ITEMS, renderItemsForContentGridSaga);
  yield takeEvery(EDITOR_ATTACH_TO_CONTAINER, attachWidgetToTemplateContainer);
  yield takeEvery(EDITOR_CONTENT_GRID_ADD_FIELD, addFieldToContentGridSaga);
  yield takeEvery(EDITOR_CONTENT_GRID_REMOVE_WIDGET, removeWidgetFromContentGridSaga);
  yield takeEvery(EDITOR_CONTENT_GRID_TOGGLE_FIELD_VISIBILITY, toggleFieldVisibilityInContentCardSaga);
  yield takeEvery(EDITOR_CONTENT_GRID_UPDATE_CONTENT, updateContentInContentGridSaga);
  yield takeEvery(EDITOR_UPDATE_WIDGET_CONTENT, updateWidgetContentSaga);
  yield takeEvery(EDITOR_CHANGE_CONTENT_GRID_CARD, changeContentGridCardSaga);
};